// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".SingleFieldLookupAddressForm-module-container-2WeUG{display:flex;flex-direction:column;gap:20px;gap:var(--spacing-sm, 20px)}.SingleFieldLookupAddressForm-module-postcodeInput-YGMZL:read-only{pointer-events:none}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "SingleFieldLookupAddressForm-module-container-2WeUG",
	"postcodeInput": "SingleFieldLookupAddressForm-module-postcodeInput-YGMZL"
};
export default ___CSS_LOADER_EXPORT___;
